export const SELLER_STAFF_SECTIONS = [
  'ORDERS',
  'PRODUCTS',
  'REVIEWS',
  'CONTACTS',
  'PROMOTION',
  'PROMO_CODES',
  'BONUSES',
  'FINANCE',
] as const;

export type SellerStaffSection = (typeof SELLER_STAFF_SECTIONS)[number];

export type SellerCabinetRole = 'OWNER' | 'STAFF';

export const SELLER_STAFF_SECTION_LABELS: Record<SellerStaffSection, string> = {
  ORDERS: 'Заказы',
  PRODUCTS: 'Товары',
  REVIEWS: 'Отзывы',
  CONTACTS: 'Точки самовывоза',
  PROMOTION: 'Продвижение',
  PROMO_CODES: 'Промокоды',
  BONUSES: 'Бонусная система',
  FINANCE: 'Финансы',
};

export interface SellerStaffAccess {
  id: number;
  phone: string | null;
  email: string | null;
  name: string | null;
  position: string | null;
  sections: SellerStaffSection[];
  orderPickupPointIds: number[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateSellerStaffDto {
  phone?: string;
  email?: string;
  name?: string;
  position?: string;
  sections: SellerStaffSection[];
  orderPickupPointIds?: number[];
}

export interface UpdateSellerStaffDto {
  name?: string | null;
  position?: string | null;
  sections?: SellerStaffSection[];
  orderPickupPointIds?: number[];
}
